import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { CaseParticipantUriBuilderParams, ParticipantsService } from '@app/core/services/participants.service';
import { Participant } from '@app/shared/models/participant';
import { BasePatchComponent } from '@app/shared/components/base/base-patch.component';
import { Directive } from "@angular/core";

@Directive()
export class ParticipantComponent extends BasePatchComponent<Participant, CaseParticipantUriBuilderParams> {

    protected paramsIdNames = ['id'];

    get caseId() {
        return this.myUriIdsList && this.myUriIdsList[0];
    }
    get participant() {
        return this.updated;
    }

    constructor(protected componentServiceBundle: ComponentServiceBundle, protected participantsService: ParticipantsService) {
        super(componentServiceBundle, participantsService);
    }

    protected generateUriBuilderParams(): CaseParticipantUriBuilderParams | undefined {
        if (this.myUriIdsList && this.myUriIdsList.length === 1) {
            return new CaseParticipantUriBuilderParams(this.caseId, this.original);
        }
    }
}
